
import Card from "@/components/Card.vue";

export default {
  async asyncData({ i18n }) {
    try {
      const locale = i18n.locale;

      // Import both nuxt-content.json, major-airports-dubai.json, and vue-content.json for the current locale

      // const nuxtContentModule = await import(
      //   `@/content/notes/${locale}/nuxt-content.json`
      // );

      const licensesModule = await import(
        `@/content/notes/${locale}/licenses.json`
      );
      const salikDubaiModule = await import(
        `@/content/notes/${locale}/salik-dubai.json`
      );
      const drivingRulesInUaeModule = await import(
        `@/content/notes/${locale}/driving-rules-in-uae.json`
      );

      const majorAirportsDubaiModule = await import(
        `@/content/notes/${locale}/major-airports-dubai.json`
      );

      const wildWadiWaterparkModule = await import(
        `@/content/notes/${locale}/wild-wadi-waterpark.json`
      );
      const insuranceModule = await import(
        `@/content/notes/${locale}/insurance.json`
      );

      // Merge the notes from all JSON files

      const licensesNotes = licensesModule.default.notes || [];
      const insuranceNotes = insuranceModule.default.notes || [];
      const salikDubaiNotes = salikDubaiModule.default.notes || [];
      const drivingRulesInUaeNotes =
        drivingRulesInUaeModule.default.notes || [];
      const wildWadiWaterparkNotes =
        wildWadiWaterparkModule.default.notes || [];
      const majorAirportsDubaiNotes =
        majorAirportsDubaiModule.default.notes || [];

      // const vueNotes = vueContentModule.default.notes || [];

      // const notes = [...wildWadiWaterparkNotes, ...majorAirportsDubaiNotes, ...vueNotes].map(
      const notes = [
        ...wildWadiWaterparkNotes,
        ...majorAirportsDubaiNotes,
        ...drivingRulesInUaeNotes,
        ...salikDubaiNotes,
        ...insuranceNotes,
        ...licensesNotes,
      ].map((note) => ({
        ...note,
        description:
          note.description.length > 40
            ? note.description.slice(0, 40) + "..."
            : note.description,
      }));

      return { notes };
    } catch (error) {
      console.error("Failed to load notes:", error);
      return { notes: [] };
    }
  },
  components: {
    Card,
  },
  computed: {
    isArabic() {
      return this.$i18n.locale === "ar";
    },
  },
};
